import { startVideoPreview } from "./previewvideo.js";
import { startAudioPreview } from "./previewaudio.js";

// --- Segmentación desactivada temporalmente ---
/*
window._recorderState = window._recorderState || {
    backgroundImage: null,
    isSegmentationActive: false,
    hasInitialized: false
};
*/
window._recorderState = window._recorderState || {
    hasInitialized: false
};

export function initPreview(type, previewArea, onReady) {
    const buttonsContainer = document.querySelector(".modal-footerwk");
    if (buttonsContainer) buttonsContainer.style.visibility = "hidden";

    if (!window._recorderState.hasInitialized) {
        previewArea.innerHTML = `
        <div class="d-flex flex-column align-items-center justify-content-center" 
             style="text-align:center; padding:30px;">
            <div class="spinner-border text-primary" role="status" style="width:40px; height:40px;"></div>
            <p style="margin-top:15px; color:#666;">Verificando permisos del navegador...</p>
        </div>
      `;
    }

    // --- Primero pedimos permisos para evitar labels vacíos ---
    const constraints = type === "audio"
        ? { audio: true }
        : { video: { width: { ideal: 1280 }, height: { ideal: 720 } }, audio: true };

    navigator.mediaDevices.getUserMedia(constraints)
        .then(async (localStream) => {
            window._activeRecorderStream = localStream;
            window._recorderState.hasInitialized = true;

            const devices = await navigator.mediaDevices.enumerateDevices();
            const mics = devices.filter((d) => d.kind === "audioinput");
            const cams = devices.filter((d) => d.kind === "videoinput");

            if (!document.getElementById("liveArea")) {
                previewArea.innerHTML = `
              <div id="liveArea" style="width:100%; text-align:center; margin-bottom:15px;"></div>
              <div id="deviceSelectors" class="d-flex flex-wrap justify-content-between align-items-center" 
                   style="gap:10px; margin-top:5px;"></div>
              <div id="permissionArea" class="text-center mt-3"></div>
            `;
            }

            const liveArea = document.getElementById("liveArea");
            const deviceSelectors = document.getElementById("deviceSelectors");
            const permissionArea = document.getElementById("permissionArea");

            if (!document.getElementById("camSelect") && !document.getElementById("micSelect")) {
                let selectorsHTML = "";

                if (type === 'video' && cams.length > 0) {
                    selectorsHTML += `
                <div style="
                    flex:1 1 48%;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    gap:6px;
                ">
                    <label for="camSelect" 
                        style="
                            font-weight:bold;
                            white-space:nowrap;
                            line-height:1;
                            margin-bottom:0;
                        ">
                        Cámara:
                    </label>
                    <select id="camSelect" class="form-control" 
                        style="
                            flex:1;
                            max-width:250px;
                            font-size:13px;
                            padding:4px 8px;
                            border-radius:5px;
                            color:#fff;
                            height:32px;
                            line-height:1;
                        ">
                        ${cams.map(c => `<option value="${c.deviceId}">${c.label || 'Cámara ' + c.deviceId.slice(0, 5)}</option>`).join('')}
                    </select>
                </div>`;
                }

                if (mics.length > 0) {
                    selectorsHTML += `
                <div style="
                    flex:1 1 48%;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    gap:6px;
                ">
                    <label for="micSelect" 
                        style="
                            font-weight:bold;
                            font-size:13px;
                            white-space:nowrap;
                            line-height:1;
                            margin-bottom:0;
                        ">
                        Micrófono:
                    </label>
                    <select id="micSelect" class="form-control" 
                        style="
                            flex:1;
                            max-width:250px;
                            font-size:13px;
                            padding:4px 8px;
                            border-radius:5px;
                            color:#fff;
                            height:32px;
                            line-height:1;
                        ">
                        ${mics.map(m => `<option value="${m.deviceId}">${m.label || 'Micrófono ' + m.deviceId.slice(0, 5)}</option>`).join('')}
                    </select>
                </div>`;
                }

                deviceSelectors.innerHTML = selectorsHTML;
            }

            // --- Función para obtener stream ---
            async function requestDevices(isDeviceChange = false) {
                const camSelect = document.getElementById("camSelect");
                const micSelect = document.getElementById("micSelect");
                const selectedCam = camSelect ? camSelect.value : undefined;
                const selectedMic = micSelect ? micSelect.value : undefined;

                if (!isDeviceChange && permissionArea) {
                    permissionArea.innerHTML = `
                        <button class="btn btn-secondary" disabled>
                            <i class="fas fa-spinner fa-spin"></i> Activando...
                        </button>
                    `;
                }

                const constraints =
                    type === "audio"
                        ? { audio: selectedMic ? { deviceId: { exact: selectedMic } } : true }
                        : {
                            audio: selectedMic ? { deviceId: { exact: selectedMic } } : true,
                            video: {
                                deviceId: selectedCam ? { exact: selectedCam } : undefined,
                                width: { ideal: 1280 },
                                height: { ideal: 720 },
                                aspectRatio: 1.7777777,
                            },
                        };

                try {
                    const localStream = await navigator.mediaDevices.getUserMedia(constraints);
                    
                    if (window._activeRecorderStream && window._activeRecorderStream !== localStream) {
                        window._activeRecorderStream.getTracks().forEach((t) => {
                            t.stop();
                        });
                    }
                    window._activeRecorderStream = localStream;

                    if (buttonsContainer) buttonsContainer.style.visibility = "visible";
                    if (permissionArea) permissionArea.innerHTML = "";

                    window._recorderState.hasInitialized = true;

                    if (type === "video") {
                        await startVideoPreview(localStream, liveArea, onReady, {
                            camSelect,
                            micSelect,
                            isDeviceChange,
                            // preservedState: window._recorderState
                        });
                    } else {
                        await startAudioPreview(localStream, liveArea, onReady);
                    }
                } catch (err) {
                    if (permissionArea) {
                        permissionArea.innerHTML = `
                          <div class="alert alert-danger" style="font-size:13px;">
                            <b>Error:</b> ${err.message}<br>
                            <button id="retryDevicesBtn" class="btn btn-secondary btn-sm mt-2">
                              <i class="fas fa-redo"></i> Reintentar
                            </button>
                          </div>`;
                        const retryBtn = document.getElementById("retryDevicesBtn");
                        if (retryBtn) retryBtn.onclick = () => requestDevices(false);
                    }
                }
            }

            // --- Verificar permisos y activar ---
            function checkPermissions() {
                if (window._recorderState.hasInitialized) {
                    requestDevices(true);
                    return;
                }

                Promise.all([
                    navigator.permissions.query({ name: "microphone" }),
                    type === "video" ? navigator.permissions.query({ name: "camera" }) : Promise.resolve(null),
                ])
                    .then(([micPerm, camPerm]) => {
                        const micGranted = micPerm?.state === "granted";
                        const camGranted = camPerm?.state === "granted" || type !== "video";

                        if (micGranted && camGranted) {
                            requestDevices(false);
                        } else if (permissionArea) {
                            permissionArea.innerHTML = `
                              <button id="activateDevicesBtn" class="btn btn-primary">
                                Activar cámara y micrófono
                              </button>`;
                            const activateBtn = document.getElementById("activateDevicesBtn");
                            if (activateBtn) activateBtn.onclick = () => requestDevices(false);
                        }

                        micPerm.onchange = () => checkPermissions();
                        if (camPerm) camPerm.onchange = () => checkPermissions();
                    })
                    .catch(() => requestDevices(false));
            }

            const existingSelectors = document.getElementById("deviceSelectors");
            if (existingSelectors && !existingSelectors.dataset.listenerAttached) {
                existingSelectors.addEventListener("change", (e) => {
                    if (["camSelect", "micSelect"].includes(e.target.id)) {
                        const isCameraChange = e.target.id === "camSelect";
                        const isMicChange = e.target.id === "micSelect";
                        
                        if (window._activeRecorder && window._activeRecorder.state === 'recording') {
                            const wasRecording = true;
                            window._activeRecorder.pause();
                            requestDevices(true).then(() => {
                                if (wasRecording && typeof window._restartRecordingWithNewDevices === 'function') {
                                    window._restartRecordingWithNewDevices();
                                } else {
                                    console.warn('Función de reinicio no disponible');
                                    if (window._activeRecorder && window._activeRecorder.state === 'paused') {
                                        window._activeRecorder.resume();
                                    }
                                }
                            });
                            return;
                        }
                        
                        if (isCameraChange) window._previousCameraIndex = e.target.selectedIndex;
                        if (isMicChange) window._previousMicIndex = e.target.selectedIndex;
                        
                        requestDevices(true);
                    }
                });
                existingSelectors.dataset.listenerAttached = "true";
            }

            navigator.mediaDevices.ondevicechange = () => {
                console.warn("🎧 Dispositivo o permiso cambiado, actualizando lista...");
                initPreview(type, previewArea, onReady);
            };

            checkPermissions();
        })
        .catch((err) => {
            previewArea.innerHTML = `
              <div class="alert alert-danger" style="font-size:13px;">
                <b>Error:</b> ${err.message}<br>
                <button id="retryDevicesBtn" class="btn btn-secondary btn-sm mt-2">
                  <i class="fas fa-redo"></i> Reintentar
                </button>
              </div>`;
            const retryBtn = document.getElementById("retryDevicesBtn");
            if (retryBtn) retryBtn.onclick = () => initPreview(type, previewArea, onReady);
        });
}
